import React from 'react';
import { formatCurrency, formatCompactCurrency } from '@/utils/format';
import { cn } from '@/utils/cn';

export interface AmountProps {
  value: number | string | null | undefined;
  format?: 'currency' | 'compact' | 'number';
  suffix?: string;
  className?: string;
  showZero?: boolean;
}

/**
 * Standard component for displaying monetary amounts and numbers.
 * Integrates directly with formatting utilities.
 */
export const Amount: React.FC<AmountProps> = ({
  value,
  format = 'currency',
  suffix = 'VNĐ',
  className,
  showZero = true
}) => {
  if (!showZero && (value === 0 || value === '0')) return null;

  const getDisplayValue = () => {
    switch (format) {
      case 'compact':
        return formatCompactCurrency(value, suffix);
      case 'number':
        return typeof value === 'number' ? value.toLocaleString('vi-VN') : (value || '0');
      case 'currency':
      default:
        return formatCurrency(value, suffix);
    }
  };

  return (
    <span className={cn("font-medium", className)}>
      {getDisplayValue()}
    </span>
  );
};
